import { useIsRetractionOnly } from "@/hooks/use-is-retraction-only";
import SettingsFormContainer, {
  SettingsFormHeader,
  SettingsFormSectionHeader,
} from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import { LockClosedIcon } from "@heroicons/react/24/solid";
import CustomerPortalNotificationsCard from "./components/customer-portal-notifications/customer-portal-notifications-card";
import DomainsList from "./components/domains-settings/domains-list";

export default function NotificationsConfigurationPage() {
  const t = useTranslation();
  const isRetractionOnly = useIsRetractionOnly();

  return (
    <SettingsFormContainer
      navigation={[
        {
          title: t("settings.customerPortal.sections.notifications.title"),
          id: "notifications",
          locked: isRetractionOnly,
        },
        {
          title: t("settings.domains.title"),
          id: "custom-domain",
        },
      ]}
    >
      <SettingsFormHeader
        title={t("sidebar.notificationsConfiguration")}
        description="Configurez les notifications envoyées à vos clients et l'adresse e-mail d'expédition."
      />

      <SettingsFormSectionHeader
        title={t("settings.customerPortal.sections.notifications.title")}
        id={"notifications"}
      />
      {isRetractionOnly ? (
        <div className="relative overflow-hidden rounded-lg border min-h-[160px]">
          <div className="pointer-events-none select-none p-6 space-y-4">
            <div className="flex items-center justify-between py-2">
              <div className="space-y-1">
                <div className="h-3 w-40 rounded bg-muted" />
                <div className="h-2 w-56 rounded bg-muted/60" />
              </div>
              <div className="h-5 w-9 rounded-full bg-muted" />
            </div>
            <div className="flex items-center justify-between py-2">
              <div className="space-y-1">
                <div className="h-3 w-44 rounded bg-muted" />
                <div className="h-2 w-52 rounded bg-muted/60" />
              </div>
              <div className="h-5 w-9 rounded-full bg-muted" />
            </div>
            <div className="flex items-center justify-between py-2">
              <div className="space-y-1">
                <div className="h-3 w-36 rounded bg-muted" />
                <div className="h-2 w-48 rounded bg-muted/60" />
              </div>
              <div className="h-5 w-9 rounded-full bg-muted" />
            </div>
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-background/70 backdrop-blur-[1.2px] px-6 text-center">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-muted">
              <LockClosedIcon className="h-4 w-4 text-muted-foreground" />
            </div>
            <p className="text-sm font-semibold text-foreground">
              Notifications
            </p>
            <p className="text-xs text-muted-foreground max-w-sm">
              Configurez les emails envoyés à vos clients à chaque étape de leur
              retour.
            </p>
          </div>
        </div>
      ) : (
        <CustomerPortalNotificationsCard />
      )}

      <SettingsFormSectionHeader
        title={t("settings.domains.title")}
        id={"custom-domain"}
      />
      <DomainsList />
    </SettingsFormContainer>
  );
}
